import { render, staticRenderFns } from "./CurrentlyWorkingOn.vue?vue&type=template&id=31bf15b0&scoped=true&"
import script from "./CurrentlyWorkingOn.vue?vue&type=script&lang=js&"
export * from "./CurrentlyWorkingOn.vue?vue&type=script&lang=js&"
import style0 from "./CurrentlyWorkingOn.vue?vue&type=style&index=0&id=31bf15b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf15b0",
  null
  
)

export default component.exports